export default (selector, options) => {
  options = Object.assign({
    animationDirection: 'right',
    animationSpeed: 16,
    pauseOnHover: false
  }, options);
  const offsetFactor = options.animationDirection !== 'left' ? -1 : 0;
  const view = document.querySelector(selector);
  if (!view) {
    return;
  }
  const childNodesLength = view.childNodes.length;
  for (let i = 0; i < childNodesLength; i++) {
    view.appendChild(view.childNodes[i].cloneNode(true));
  }
  let rem = getComputedStyle(document.body).fontSize;
  rem = rem.substring(0, rem.length - 2);
  rem = Number.parseFloat(rem);
  let width = 0;
  const onResize = () => {
    width = view.scrollWidth / 2;
  };
  window.addEventListener('resize', onResize);
  onResize();
  let paused = false,
    offset = 0;

  // Animate only in idle mode; while editing (non-idle) the marquee holds still.
  const canAnimate = () => !window.editor || window.editor._mode === 'idle';

  // A single loop advances the offset. Pausing only stops the advance, so there
  // is never a second loop and resuming continues from the exact same position.
  // The loop ends when the element leaves the DOM (e.g. an editor re-render).
  const step = async () => {
    while (view.isConnected) {
      await new Promise(requestAnimationFrame);
      if (paused || !canAnimate()) {
        continue;
      }
      offset += (offsetFactor ? options.animationSpeed : -options.animationSpeed) / rem;
      const localOffset = offset % width + offsetFactor * width;
      view.style.transform = 'translateX(' + localOffset.toFixed(3) + 'px)';
    }
  };
  step();
  if (options.pauseOnHover) {
    // Listen on the static parent, not the moving row: the row shifts under the
    // cursor, so gaps between items would otherwise fire mouseleave and resume.
    // It also lets both rows of a double marquee pause together.
    const hoverTarget = view.parentElement || view;
    const pause = () => {
      paused = true;
    };
    const resume = () => {
      paused = false;
    };
    hoverTarget.addEventListener('mouseenter', pause);
    hoverTarget.addEventListener('mouseleave', resume);
    // Keyboard focus within the row pauses too, so a focused link stays reachable.
    hoverTarget.addEventListener('focusin', pause);
    hoverTarget.addEventListener('focusout', resume);
  }
};